import { render, staticRenderFns } from "./CadastroConfigList.vue?vue&type=template&id=5ca9e7bb&"
import script from "./CadastroConfigList.vue?vue&type=script&lang=js&"
export * from "./CadastroConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports